import { render, staticRenderFns } from "./GraphDetail22.vue?vue&type=template&id=9f8e12ea&scoped=true&"
import script from "./GraphDetail22.vue?vue&type=script&lang=js&"
export * from "./GraphDetail22.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9f8e12ea",
  null
  
)

export default component.exports